import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Statistics from '../../components/main/Statistics'


class StatisticsContainer extends React.Component {

    render() {
        return (
            <Statistics />
        )
    }

}

function mapStateToProps(state) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({  }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsContainer)